// @flow
import { call, put, takeEvery } from 'redux-saga/effects'
import { REQUEST, authenticationSuccess, authenticationError } from './'

const auth = (username, password) => {
  const url = process.env.REACT_APP_AUTH_GATEWAY || ''
  const requestBody = { username, password }
  return fetch(url, {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestBody)
  })
    .then(response => response.json())
    .then(json => json)
}

function* authenticate(action) {
  try {
    const {
      payload: { username = '', password = '' }
    } = action
    const response = yield call(auth, username, password)
    if (!response.error) {
      yield put(authenticationSuccess())
    } else {
      yield put(authenticationError())
    }
  } catch (error) {
    yield put(authenticationError())
  }
}

// $FlowFixMe
export function* authSaga() {
  // $FlowFixMe
  yield takeEvery(REQUEST, authenticate)
}



// WEBPACK FOOTER //
// ./src/ducks/auth/saga.js